import axios from 'axios';

const login = async (email, password) => {
  const devicePid = localStorage.getItem('devicePid');

  const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/auth/login`, {
    email,
    password,
    devicePid,
  });

  return response;
};

export const logout = async () => {
  const refreshToken = localStorage.getItem('refreshToken');

  await axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/auth/logout`, {
    refreshToken,
  });

  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('role');
  localStorage.removeItem('companyPid');
};

export const refreshAccessToken = async () => {
  const refreshToken = localStorage.getItem('refreshToken');

  const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/auth/refresh`, {
    refreshToken,
  });

  localStorage.setItem('token', response.data.response.accessToken);

  return response;
};

export const sendOTP = async (email) => {
  return axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/auth/otp/send`, { email });
};

export const verifyOTP = async (phone, otp) => {
  const devicePid = localStorage.getItem('devicePid') ?? "";
  return axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/auth/otp/verify`, { phone, otp: String(otp), devicePid });
};

export const changePassword = async (currentPassword, newPassword, confirmPassword) => {
  return axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/auth/change-password`, {
    currentPassword,
    newPassword,
    confirmPassword,
  });
};

export default login;
